<template>
  <div class="goods-detail">
    <div class="download-btn-con">
      <download-btn />
    </div>
    <div class="detail-con">
      <!--头部-->
      <div class="header">
        <img class="img" :src="detail.coverPath+'?imageView2/0/w/700/h/560'" alt="">
        <div class="video-con" v-if="detail.purchaseGoods  && detail.filePath">
          <video v-if="$route.query.courseType==='VIDEO'" class="video" controls :src="detail.filePath" :poster="detail.coverPath"
                 playsinline="" x5-playsinline="" webkit-playsinline="" x-webkit-airplay="allow"></video>
          <audio v-if="$route.query.courseType==='AUDIO'" class="audio" controls :src="detail.filePath" :poster="detail.coverPath"></audio>
        </div>
      </div>
      <div class="goods-detail-msg">
        <div class="list-title"><span class="type">{{ knowledgeTypeName($route.query.courseType) }}</span>{{ detail.title }}</div>
        <div class="price" v-if="!detail.courseSeriesGoodsId">
          <span class="red">{{ detail.sellPrice===0?'免费':('￥'+(detail.sellPrice||'')) }}</span>
          <s class="original-price" v-if="detail.originalPrice">原价：{{ detail.originalPrice }}</s>
          <span class="member-price" v-if="detail.shopMemberPrice">会员价：{{ detail.shopMemberPrice }}</span>
        </div>
        <div class="sub-text" v-if="$route.query.courseType!==null && $route.query.courseType!=='VIDEO' && $route.query.courseType!=='AUDIO'">
          <span class="num" style="color: #f74d4d;">开播时间:{{ detail.startTime }}</span>
          <span style="float: right;">
          <span class="num">收藏:{{ detail.collectUserCount }}</span>
        <span class="num">已售:{{ detail.salesVolume }}</span>
        </span>

        </div>
        <div class="sub-text" v-if="$route.query.courseType===null || $route.query.courseType==='VIDEO' || $route.query.courseType==='AUDIO'">
          <span class="num" v-if="$route.query.courseType===null">共{{ detail.planCourseCount }}期<span v-if="detail.currentCourseCount">，已更新至{{ detail.currentCourseCount }}期</span></span>
          <span class="num" v-if="$route.query.courseType!==null">时长:{{ formatSeconds($route.query.courseType, detail.duration) }}</span>
          <span class="num">收藏:{{ detail.collectUserCount }}</span>
          <span class="num">已售:{{ detail.salesVolume }}</span>
          <span class="complaint" @click="goGoodsComplaintType">投诉</span>
        </div>
        <div class="other" v-if="$route.query.courseType===null || $route.query.courseType==='VIDEO' || $route.query.courseType==='AUDIO'">
          <!--<span class="check">永久回听</span>-->
          <span class="check" @click="showNotice=true">购买须知</span>
        </div>
      </div>
      <van-popup v-model="showNotice" :close-on-click-overlay="true">
        <div class="notice-con">
          <div class="title">购买须知：</div>
          <div class="text">该课程为虚拟内容服务，购买成功后概不支持退款，请谅解。</div>
          <div class="text">版权归原作者所有，严禁翻录和在任何第三方平台传播，违者将追究法律责任。</div>
          <div class="text">如有其它疑问，可在“云柑社区”APP中与内容提供商沟通后再购买。</div>
        </div>
      </van-popup>
      <div class="bg-10px"></div>

      <div class="shop-list">
        <shop-list />
      </div>


      <div class="bg-10px"></div>
      <!--专栏详情-->
      <div class="special-column" v-if="$route.query.courseType===null">
        <van-tabs class="special-column-tabs" :line-width="40" v-model="specialColumnActive" :lazy-render="false">
          <van-tab title="详情">
            <div class="special-column-details" ref="specialColumnDetail">

            </div>
          </van-tab>
          <van-tab title="目录">
            <div class="special-column-list-con">
              <div class="list" v-for="(item, i) in detail.courseCatalogList" :key="i" @click="goCurriculumDetail(item.goodsId, item.courseType)">
                <div class="icon-con"><img class="catalog-icon" src="../../assets/mall/catalog.png" alt=""></div>
                <div class="title-con">
                  <div class="title"><span class="type">{{ knowledgeTypeName(item.courseType) }}</span>{{ item.title }}</div>
                  <div class="duration" v-if="item.duration">时长 {{  formatSeconds(item.courseType, item.duration) }}</div>
                </div>
              </div>
            </div>
          </van-tab>

        </van-tabs>
      </div>
      <!--课程详情-->
      <div class="curriculum" v-if="$route.query.courseType==='AUDIO' || $route.query.courseType==='VIDEO'">
        <div class="curriculum-title">课程详情</div>
        <div class="curriculum-details" ref="curriculumDetail">

        </div>
      </div>
      <!--直播详情-->
      <div class="live-broadcast" v-if="$route.query.courseType!==null && $route.query.courseType!=='VIDEO' && $route.query.courseType!=='AUDIO'">
        <div class="live-broadcast-title">直播介绍</div>
        <div class="anchor">主讲人: {{ anchor }}</div>
        <div class="live-broadcast-details" ref="liveBroadcastDetail">

        </div>
      </div>

      <div class="bg-10px"></div>
      <van-cell v-if="(shopDetail.userId!==userOpenId) && detail.agentSellEnalbed" is-link title="我要分销" @click="goAppDownload"></van-cell>

      <div class="outer-links-con" v-if="detail.outerLinks && detail.hasOuterLink">
        <div class="img-con">
          <img class="img" :src="detail.outerLinks[0].iconPath +'?imageView2/0/w/54/h/54'" alt="">
        </div>
        <div class="text-con">
          <div class="name">{{ detail.outerLinks[0].title }}</div>
          <div class="text">{{ detail.outerLinks[0].description || '&nbsp;' }}</div>
        </div>
        <div class="btn-con">
          <div class="btn" @click="goOuter(detail.outerLinks[0].url)">{{ detail.outerLinks[0].linkType==='APP'? '立即下载':'立即前往' }}</div>
        </div>
      </div>
      <div class="technical-support">云柑社区提供技术支持</div>


    </div>

    <buy-curriculum v-if="detail.shelvesStatus==='ON_SHELF'" />
    <wx-config v-on:wxConfigReady="wxConfigReady" />

  </div>
</template>

<script>
import { getUserByUserInfo } from '@/api/login'
import { columnDetail, courseDetail, directDetail } from '@/api/mall/mallGoods'
import { introduce } from '@/api/mall/mallShop'
// import { getUserInfo } from '@/api/my'
import DownloadBtn from '@/components/downloadBtn'
import buyCurriculum from './components/buyCurriculum';
import shopList from './components/ShopList'
import wxConfig from '@/components/weixin/wxConfig'
export default {
  components: {
    buyCurriculum,
    shopList,
    wxConfig,
    DownloadBtn,
  },
  data () {
    return {
      shopId: '', // 当url中没传shopId 时，使用该字段，字段值从商品详情中获取
      showNotice: false,// 展示购买须知
      userOpenId: this.session('userOpenId'),
      specialColumnActive: 1,
      detail: {},
      shopDetail: {},
      anchor: '', //主播昵称
      detailMobileHtml: '', // 详情 渲染 内容
      outerLinks: [], //商家推广外链
      outInviteCode: '',// 商品被 分享用户分享，用openId 获取的邀请码
      origin: window.location.origin,
    }
  },
  computed: {

  },
  created(){
    window.scrollTo(0,0);
    // console.log(this.$route.query)
    if(this.$route.query.courseType === null || this.$route.query.courseType === 'null' || this.$route.query.courseType === '6'){
      console.log('专栏详情')
      this.getColumnDetail()
    }else if( this.$route.query.courseType === 'VIDEO' || this.$route.query.courseType === 'AUDIO' || this.$route.query.courseType === '5'){
      console.log('课程详情')
      this.getCourseDetail()
    }else {
      console.log('直播详情')
      this.getDirectDetail()
    }
    if(this.$route.query.shopId){
      this.shopId = this.$route.query.shopId
      this.getShopHome()
    }
    if(this.$route.query.inviteUserId){
      this.getUserByUserInfo(this.$route.query.inviteUserId)
    }
    // console.log(this.$route.query.courseType)
    // console.log(this.$route.query.inviteUserId)

  },

  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    goAppDownload(){
      this.appDownload({inviteCode: this.session('user').inviteCode || '0608'})
    },

    //获取店铺信息
    getShopHome() {
      introduce({shopId: this.$route.query.shopId || this.shopId}).then(res=>{
        this.shopDetail = res.data;
        this.$store.dispatch('mall/changeShopDetail', res.data)
      })
    },

    getColumnDetail() { // 专栏详情
      let req = { goodsId: this.$route.query.goodsId, shopId: this.$route.query.shopId };
      if(this.$route.query.inviteUserId){
        req.inviteUserId = this.$route.query.inviteUserId
      }
      columnDetail(req).then(res=>{
        this.detail = res.data;
        this.$store.dispatch('mall/changeGoodsDetail', res.data)
        document.title=this.detail.title
        this.initDetailCon(res.data.detailMobile, 'specialColumnDetail');
        if(!this.$route.query.shopId){ // 当url中无shopId时，从商品详情中的shopId调取店铺接口
          this.shopId = res.data.shopId
          this.getShopHome()
        }
      })
    },
    getCourseDetail() { // 课程详情(视频，音频)
      let req = { goodsId: this.$route.query.goodsId, shopId: this.$route.query.shopId };
      if(this.$route.query.inviteUserId){
        req.inviteUserId = this.$route.query.inviteUserId
      }
      courseDetail(req).then(res=>{
        this.detail = res.data;
        this.detail.agentSellEnalbed = res.data.agentSellEnabled;
        this.$store.dispatch('mall/changeGoodsDetail', this.detail)
        document.title=this.detail.title
        this.initDetailCon(res.data.detailMobile, 'curriculumDetail');
        if(!this.$route.query.shopId){ // 当url中无shopId时，从商品详情中的shopId调取店铺接口
          this.shopId = res.data.shopId
          this.getShopHome()
        }
      })
    },
    getDirectDetail() { // 直播详情
      let req = { goodsId: this.$route.query.goodsId, shopId: this.$route.query.shopId };
      if(this.$route.query.inviteUserId){
        req.inviteUserId = this.$route.query.inviteUserId
      }
      directDetail(req).then(res=>{
        this.detail = res.data;
        this.$store.dispatch('mall/changeGoodsDetail', res.data)
        document.title=this.detail.title
        this.initDetailCon(res.data.detailMobile, 'liveBroadcastDetail');
        if(!this.$route.query.shopId){ // 当url中无shopId时，从商品详情中的shopId调取店铺接口
          this.shopId = res.data.shopId
          this.getShopHome()
        }
        this.getUserByUserInfo(this.detail.lecturerUserId)
      })
    },

    initDetailCon(val, con) {
      if(!val){return false}
      if( val && val.indexOf('[{"')===0 && val.indexOf('"}]') ){
        let detailMobile = JSON.parse(val);
        this.detailMobileHtml = ``;
        detailMobile.forEach( (item, i) => {
          // playsinline="true"
          // webkit-playsinline="true"
          // x-webkit-airplay="true"
          // x5-video-player-type="h5"
          // x5-video-player-fullscreen="true"
          if(item.type === 'image'){
            this.detailMobileHtml += `<img class="details-img" src="${ item.richText }" />`
          }else if(item.type === 'video'){
            this.detailMobileHtml += `<video class="details-video" src="${ item.richText }" style=""
                                        playsinline="" x5-playsinline="" webkit-playsinline="" x-webkit-airplay="allow"
                                        width="100%" height="420" controls ></video>`
          }else if(item.type === 'text'){
            this.detailMobileHtml += `<p class="details-text">${ item.richText }</p>`
          }else{
            this.detailMobileHtml += `<p class="details-text">${ item.richText }</p>`
          }
        });
        this.$refs[con].innerHTML = this.detailMobileHtml;
      }else {
        val && (this.$refs[con].innerHTML = `<div class="details-text">${ val }</div>`);
      }
    },
    // 专栏课程跳转至商品详情
    goCurriculumDetail(goodsId, courseType) {
      console.log('跳转至专栏下的课程')
      let query = {
        goodsId: goodsId,
        shopId: this.$route.query.shopId,
        courseType: courseType
      }
      if(this.$route.query.inviteUserId){
        query.inviteUserId = this.$route.query.inviteUserId
      }
      this.$router.push({name: 'curriculumDetail', query })
    },

    // getUserInfo(openId){
    //   getUserInfo({openId}).then(res=>{
    //     this.anchor = res.data.nickname;
    //   })
    // },

    // 获取用户信息
    getUserByUserInfo(openId){
      getUserByUserInfo({openId}).then(res=>{
        if(res.data){
          this.outInviteCode = res.data.inviteCode
          this.anchor = res.data.nickname;
        }
      })
    },

    // 推广链接跳转
    // goInvitePage(){
    //   let inviteCode = '';
    //   if(this.$route.query.inviteUserId){ //如果邀请链接中有 邀请人的openId
    //     inviteCode = this.outInviteCode;
    //   }else {
    //     inviteCode = this.session('user').inviteCode || '0608';
    //   }
    //   let url = '/h5/register?inviteCode='+ inviteCode
    //   this.$router.push( url );
    // },
    goOuter(url){
      window.location.href = url;
    },

    // 微信分享
    wxConfigReady(){
      window.setTimeout(()=>{
        //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
        window.wx.updateAppMessageShareData({
          title: this.session('user').nickname + '给你分享了一门好课', // 分享标题
          desc: this.detail.title, // 分享描述
          link: this.origin + '/mall/goodsDetail?goodsId=' + this.$route.query.goodsId +
          '&shopId=' + (this.$route.query.shopId||this.shopId) +
          '&courseType' + ( this.$route.query.courseType?('='+this.$route.query.courseType): '') +'&inviteUserId=' + this.session('userOpenId'),
          imgUrl: this.detail.coverPath, // 分享图标
          success: function () {
            // 设置成功
            console.log('商品详情 设置分享朋友成功！')
          }
        });
        // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
        window.wx.updateTimelineShareData({
          title: this.session('user').nickname + '给你分享了一门好课', // 分享标题
          link: this.origin + '/mall/goodsDetail?goodsId=' + this.$route.query.goodsId +
          '&shopId=' + (this.$route.query.shopId||this.shopId) +
          '&courseType=' + ( this.$route.query.courseType?('='+this.$route.query.courseType): '')  +'&inviteUserId=' + this.session('userOpenId'),
          imgUrl: this.detail.coverPath, // 分享图标
          success: function () {
            // 设置成功
            console.log('商品详情 设置分享朋友圈成功！')
          }
        })
      },300)
    },

    //
    goGoodsComplaintType(){
      this.$router.push({name: 'goodsComplaintType', query: this.$route.query})
    },
  }
}
</script>

<style scoped lang="less">
.goods-detail{
  position: relative;
  width: 100%;height: 100%;
  .download-btn-con{
    position: fixed;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 55px;
  }
  .detail-con{
    position: absolute;
    top: 55px;
    left: 0;
    right: 0;
    bottom: 50px;
    overflow-y: auto;
    z-index: 0;
  }
  .goods-detail-header{
    background-color: transparent;
    position: absolute;
    z-index: 9;
    width: 100%;
    .van-nav-bar__left{
      .van-icon{
        color: #fff !important;
      }
    }
    .van-nav-bar__title{
      color: #fff;
    }
  }
  .header{
    width: 375px;
    height: 280px;
    position: relative;
    /*padding-top: 46px;*/
    .img{
      display: block;
      width: 100%;
      height: 100%;
    }
    .video-con{
      position: absolute;
      top: 0;
      width: 375px;
      height: 280px;
      /*padding-top: 46px;*/
      /*background-color: #000;*/
      .video{
        background-color: #000;
      }
      .video, .audio{
        width: 100%;
        height: 100%;
      }
    }
  }
  .goods-detail-msg{
    padding: 12px;
    .list-title{
      margin-bottom: 6px;
      padding-bottom: 2px;
      font-size: 18px;
      color: #000;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      .type{
        display: inline-block;
        height: 18px;
        line-height: 18px;
        margin: 0 5px 0 0;
        font-size: 9px;
        border: .75px solid #1585f3;
        color: #1585f3;
        border-radius: 2px;
        padding: 0 3px;
        vertical-align: top;
      }
    }
    .price{
      line-height: 24px;
      .red{
        padding-right: 10px;
        font-size: 16px;
        color: #f74d4d;
      }
      .original-price{
        font-size: 10px;
        color: #999;
      }
      .member-price{
        font-size: 10px;
        color: #f74d4d;
        border-radius: 4px;
        border: 1px solid #f74d4d;
        padding: 4px 6px;
        margin-left: 12px;
        line-height: 1;
      }
    }
    .sub-text{
      font-size: 10px;
      color: #999;
      line-height: 24px;
      .num{
        padding-right: 12px;
      }
      .complaint{
        font-size: 14px;
        float: right;
        padding-left: 16px;
        background: url("../../assets/mall/complaint.png") no-repeat 0 50%;
        background-size: 10px 10px;
      }
    }
    .other{
      font-size: 12px;
      color: #999;
      line-height: 24px;
      .check{
        padding-left: 16px;
        padding-right: 24px;
        background: url("../../assets/mall/check.png") no-repeat 0 50%;
        background-size: 10px 10px;
      }
    }
  }
  .shop-con{
    .shop{
      display: flex;
      .img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
      }
      .name-con{
        display: inline-flex;
        flex-direction: column;
        .name{
          color: #070707;
          font-size: 16px;
        }
        .num-com{
          .num{
            padding-right: 20px;
            color: #999;
            font-size: 10px;
          }

        }
      }
    }
    .van-icon{
      height: 40px;
      line-height: 40px;
    }
  }

  .shop-list{

  }

  .special-column{
    .special-column-tabs{
      .special-column-list-con{
        .list{
          display: flex;
          height: 60px;
          border-bottom: .5px solid #edecec;
          .icon-con{
            width: 44px;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            .catalog-icon{
              display: block;
              width: 22px;
              height: 22px;
            }
          }
          .title-con{
            flex: 1;
            padding: 12px 0;
            .title{
              line-height: 21px;
              font-size: 14px;
              color: #070707;
              width: 320px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              .type{
                margin: 0 5px 0 0;
                font-size: 9px;
                border: .75px solid #1585f3;
                color: #1585f3;
                border-radius: 2px;
                padding: 1px 2.5px;
              }
            }
            .duration{
              font-size: 12px;
              color: #999;
              padding-top: 4px;
            }
          }
        }
      }
    }
  }
  .curriculum{
    .curriculum-title{
      line-height: 44px;
      font-size: 16px;
      text-align: center;
      color: #070707;
      border-bottom: .5px solid #eee;
    }
  }
  .live-broadcast{
    .live-broadcast-title{
      line-height: 44px;
      font-size: 16px;
      text-align: center;
      color: #070707;
      border-bottom: .5px solid #eee;
    }
    .anchor{
      font-size: 14px;
      padding: 12px;
      /*border-bottom: .5px solid #edecec;*/
    }
  }

  .download-con, .outer-links-con{
    display: flex;height: 55px;background-color: #e0f5ff;
    /*margin-bottom: 1px;*/
    .img-con{
      width: 60px;
      display: inline-flex;justify-content: center;align-items: center;
      .img{
        display: block;width: 37px;height: 37px;border-radius: 5px;
      }
    }
    .text-con{
      flex: 1;display: inline-flex;flex-direction: column;
      justify-content: center;
      .name{
        font-size: 14px;color: #000;padding-bottom: 2px;
      }
      .text{font-size: 11px;color: #666;}
    }
    .btn-con{
      width: 87px;
      display: inline-flex;justify-content: center;align-items: center;
      .btn{
        display: inline-flex;justify-content: center;align-items: center;
        width: 63px;height: 28px;
        border: 1px solid #2686e8;color: #2686e8;border-radius: 3px;font-size: 11px;
      }
    }
  }

  .technical-support{
    background-color: #f4f4f4;
    text-align: center;
    font-size: 12px;
    color: #999;
    padding: 24px 0;
  }


  .notice-con{
    padding: 14px;width: 340px;
    .title{
      font-size: 16px;padding-bottom: 12px;
    }
    .text{font-size: 14px;margin-bottom: 10px;text-indent:2em;
      &:last-child{margin-bottom: 0;}
    }
  }
}
</style>
<style lang="less">
.goods-detail{
  .special-column{
    .special-column-tabs{
      .van-tabs__wrap{
        /*z-index: 1;*/
        /*right: 0;*/
        .van-tabs__line{
          background-color: #2590e2;
        }
      }
    }
  }
  .special-column-details, .curriculum-details, .live-broadcast-details{
    padding: 12px;
    .details-img{
      display: block;
      max-width: 100%;
      padding: 6px 0;
      margin: 0 auto;
    }
    .details-text{
      font-size: 14px;
      line-height: 24px;
      text-indent: 2em;
      color: #242424;
    }
    .details-video{
      display: block;
      max-width: 100%;
      max-height: 420px;
      /*padding: 6px 0;*/
      margin: 6px auto;
      object-fit: fill;
      background-color: #000;
    }
  }
}
</style>
